app.service("PatientAuditAPI", [
	"$http",
	"ENV",
	"Session",
	function ($http, ENV, Session) {
        function delay(milliseconds){
            return new Promise(resolve => {
                setTimeout(resolve, milliseconds);
            });
        }
		var service = {
			isProcessing: false,
			auditObject: null,
			// The patient an audit is open, or being opened, for. A start is async (POST, plus a 2s
			// wait after closing the previous one), so without this a quick A -> B -> C switch, or an
			// end while the POST is in flight, leaves an audit open on a patient nobody is viewing.
			activePatientId: null,
			startAudit: async function (patient_id) {
                if(service.activePatientId === patient_id){
                    return;
                }
                service.activePatientId = patient_id;
                if(service.auditObject && service.auditObject.patient_id !== patient_id){
                    service.endAudit(service.auditObject.patient_id);
                    await delay(2000);
                    if(service.activePatientId !== patient_id){
                        return;
                    }
                }
				$http({
					method: "POST",
					url: ENV.API + `/api/patient-audit/patient/${encodeURIComponent(patient_id)}?timezone=${encodeURIComponent(Session.practice.timezone)}`,
					headers: {
						Authorization: "Bearer " + Session.token,
                        "X-PRACTICE-ID": `${Session.practice.id}`,
					},
				}).then(
					function successCallback(response) {
						const audit = { patient_audit_id: response.data.patient_audit_id, patient_id: response.data.patient_id };
						if(service.activePatientId !== patient_id){
							// Patient was closed or switched while this was in flight - close it straight away.
							closeAudit(audit.patient_id, audit.patient_audit_id);
							return;
						}
						service.auditObject = audit;
					},
					function errorCallback(response) {
						console.error("Patient audit start failed", response && response.status);
                        if(service.activePatientId === patient_id){
                            service.activePatientId = null;
                        }
					}
				);
			},

			endAudit: function (patient_id) {
				if (service.activePatientId === patient_id) {
					service.activePatientId = null;
				}
				if (!service.auditObject) {
					return;
				} else if (service.auditObject && service.auditObject.patient_id !== patient_id) {
					//should end current session
                    console.error('cannot end audit')
                    return;
				}
                const _patient_id = service.auditObject.patient_id;
                const _patient_audit_id = service.auditObject.patient_audit_id;
                service.auditObject = null;
				closeAudit(_patient_id, _patient_audit_id);
			},
		};

		function closeAudit(_patient_id, _patient_audit_id) {
				$http({
					method: "PUT",
					url: ENV.API + `/api/patient-audit/patient/${_patient_id}/audit/${_patient_audit_id}`,
					headers: {
						Authorization: "Bearer " + Session.token,
                        "X-PRACTICE-ID": `${Session.practice.id}`,
					},
				}).then(
					function successCallback(response) {},
					function errorCallback(response) {
						console.error("Patient audit end failed", response && response.status);
					}
				);
		}

		return service;
	},
]);
